import { createContext, useContext } from 'react';

import { SHELL_PORTAL } from './shellPortal';

/**
 * Two contexts on purpose. `ShellContext` holds the stable API and the rare UI flags pages read;
 * `ShellChromeContext` holds what pages registered and changes on every registration. A page that
 * only registers chrome must never re-render because another registered theirs, or registration
 * would cascade. Both are null outside a shell.
 */
export const ShellContext = createContext(null);
export const ShellChromeContext = createContext(null);
// True only inside the shell's page area (the routed content under the top bar). Modals and
// board widgets set it back to false so a table inside them never takes over the top bar.
export const ShellPageContext = createContext(false);

// The dock rail's element for tools the portal adds (the admin's AI chat), or null while no dock
// is on screen, as on phones; such a tool then shows itself some other way.
export const DockToolsContext = createContext(null);

export const useShell = () => useContext(ShellContext);
export const useDockTools = () => useContext(DockToolsContext);
export const useShellChrome = () => useContext(ShellChromeContext);
export const useShellPage = () => useContext(ShellPageContext);
// Which portal's shell this is; state that must not cross portals (dock tabs, charts) keys on it.
export const useShellPortal = () => useShell()?.portal || SHELL_PORTAL.PRACTICE;

export const useIsShellHosted = () => {
  const shell = useShell();
  const inPage = useShellPage();
  return !!shell && inPage;
};
